export default __webpack_public_path__ + "static/media/iam_m1.9788661e.png";